import * as Scrivito from "scrivito";
import { times } from "lodash-es";
import TableRowWidget from "../TableRowWidget/TableRowWidgetClass";
import TableRowWidgetComponent from "../TableRowWidget/TableRowWidgetComponent";
import TableCellWidget from "../TableCellWidget/TableCellWidgetClass";
import { AddMoreColumns } from "../TableRowWidget/AddMoreCoumns";

Scrivito.provideComponent("TableWidget", ({ widget }) => {
  const description = widget.get("description");
  const rows = widget.get("rows");
  const summaryRows = widget.get("summaryRows");
  const headers = widget.get("headers").map((header) => {
    if (header.startsWith("null-")) {
      return null;
    }
    return header;
  });

  return (
    <>
      {description && (
        <p className="sr-only" id={`description-${widget.id()}`}>
          {description}
        </p>
      )}
      <AddMoreColumns rows={rows} summaryRows={summaryRows} attribute="cells" />
      <table
        className="table-features"
        aria-describedby={
          description ? `description-${widget.id()}` : undefined
        }
      >
        <caption className="sr-only">{widget.get("caption")}</caption>
        <thead>
          <tr>
            {headers.map((header, idx) => (
              <th key={header + idx} scope="column">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {widget.get("rows").map((rowWidget, index) => (
            <TableRowWidgetComponent
              key={`${rowWidget.id()}${index}`}
              rowWidget={rowWidget}
              rows={rows}
              summaryRows={widget.get("summaryRows")}
              headers={headers}
              firstColumnAsHeader={widget.get("firstColumnAsHeader")}
              isFirstRow={index === 0}
            />
          ))}
          <AddMoreRows
            widget={widget}
            attribute="rows"
            title="Click to add a row"
          />
        </tbody>
        <tfoot>
          {widget.get("summaryRows").map((rowWidget, index) => (
            <TableRowWidgetComponent
              key={`${rowWidget.id()}-summary-${index}`}
              rowWidget={rowWidget}
              rows={widget.get("rows")}
              summaryRows={widget.get("summaryRows")}
              headers={headers}
              isFirstRow={false}
            />
          ))}
          <AddMoreRows
            widget={widget}
            attribute="summaryRows"
            title="Click to add a summary row"
            maxRows={1}
            color="white"
          />
        </tfoot>
      </table>
    </>
  );
});

const AddMoreRows = Scrivito.connect(
  ({ widget, title, attribute, maxRows, color }) => {
    if (!Scrivito.isInPlaceEditingActive()) {
      return null;
    }

    const currentRows = widget.get(attribute);
    if (maxRows && currentRows.length >= maxRows) {
      return null;
    }

    const cellsNumber =
      (widget.get("rows").length &&
        widget.get("rows")[0].get("cells") &&
        widget.get("rows")[0].get("cells").length) ||
      0;

    const cells = [];
    times(cellsNumber, () => cells.push(new TableCellWidget({})));

    return (
      <tr>
        <th colSpan={cellsNumber}>
          <div className="text-center">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                const updatedAttributes = {};
                updatedAttributes[attribute] = [
                  ...currentRows,
                  new TableRowWidget({
                    cells,
                    verticalAlignment:
                      attribute === "summaryRows" ? "middle" : "top",
                  }),
                ];
                widget.update(updatedAttributes);
              }}
              className={`text-${color || "black"}`}
            >
              {title}
            </a>
          </div>
        </th>
      </tr>
    );
  }
);
